import { React, useEffect, useState } from "react";
import './ActionForm.css';
import { CustomSwitchBox, extractKeyName, fieldTypeDic, isJsonString, sortArray } from "../../utils/externalFunc";
import { useSelector } from "react-redux";
import { getCities } from "../../utils/apiUtils";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function ProjectSection(props){

    const store = useSelector(state => state.reducer)
    const [hoursArray, setHoursArray] = useState([])
    const [formErrors, setFormErrors] = useState({})
    const [mainArray, setMainArray] = useState(props.stepInfo.FormFields)
    const [citiesList, setCitiesList] = useState([])
    const [selectedCity, setSelectedCity] = useState(null)
    const [populationOptions, setPopulationOptions] = useState([])
    const [activityFieldOptions, setActivityFieldOptions] = useState([])
    const [projectTypeOptions, setProjectTypeOptions] = useState([])

    useEffect(() => {
        buildHoursArray()
        fetchCities()
        // Convert projectPopulation object to array for select options
        if (props.extraData?.projectPopulation) {
            const populationArray = Object.entries(props.extraData.projectPopulation).map(([key, value]) => ({
                key: key,
                title: value
            }))
            setPopulationOptions(populationArray)
        }
        // Convert activityFields object to array for select options
        if (props.extraData?.activityFields) {
            const activityArray = Object.entries(props.extraData.activityFields).map(([key, value]) => ({
                key: key,
                title: value
            }))
            setActivityFieldOptions(activityArray)
        }
        // Convert projectTypes object to array for select options
        if (props.extraData?.projectTypes) {
            const projectTypeArray = Object.entries(props.extraData.projectTypes).map(([key, value]) => ({
                key: key,
                title: value
            }))
            setProjectTypeOptions(projectTypeArray)
        }
    }, [props.extraData])

    const fetchCities = () => {
        getCities().then(res => {
            setCitiesList(res.data)
            // Initialize selected city if exists in form state
            if(props.formValsLocal.ProjectDetails?.CityId) {
                const city = res.data.find(c => c._id === props.formValsLocal.ProjectDetails.CityId)
                setSelectedCity(city || null)
            }
        }).catch(error => {
            console.error("Error fetching cities:", error)
        })
    }

    const buildHoursArray = () => {
        let hours = [];
        for(let i = 0; i < 24; i++){
           let fullHour = i < 10 ? '0' + i + ':' + '00' : i + ':' + '00'
           let halfHour = i < 10 ? '0' + i + ':' + '30' : i + ':' + '30'
           let fullHourValue = fullHour + ':' + '00'
           let halfHourValue = halfHour + ':' + '00'
            hours.push({hour: fullHour, hourValue: fullHourValue})
            hours.push({hour: halfHour, hourValue: halfHourValue})
        }
        setHoursArray(hours)
    }

    const updateProjectDetailsObj = (value, path) => {
        setFormErrors({...formErrors, [path]: ""})
        props.setFormState({...props.formValsLocal.ProjectDetails, [path]: value}, "ProjectDetails")
    }

    const handleCityChange = (event, newValue) => {
        setSelectedCity(newValue)
        // Store the city ID in form state
        const cityId = newValue ? newValue._id : ""
        // Clear error when city is selected
        if (newValue) {
            setFormErrors({...formErrors, "CityId": ""})
        }
        updateProjectDetailsObj(cityId, "CityId")
    }

    useEffect(() => {
        setFormErrors(props.errorsObjReady)
    }, [props.errorsObjReady])

    useEffect(() => {
        let arr = sortArray(props.stepInfo.FormFields)
        setMainArray(arr)
    }, [props.stepInfo.FormFields])

    // Update selected city when form data changes (for edit mode)
    useEffect(() => {
        if (citiesList.length > 0 && props.formValsLocal.ProjectDetails?.CityId) {
            const city = citiesList.find(c => c._id === props.formValsLocal.ProjectDetails.CityId)
            if (city && (!selectedCity || selectedCity._id !== city._id)) {
                setSelectedCity(city)
            }
        }
    }, [props.formValsLocal.ProjectDetails?.CityId, citiesList])

    return  <>  <div className="ProjectSection my-5">
                    <h2 className="font-xl text-center primary_color f-bold">{props.stepInfo.Title}</h2>
                </div>
            <form action="" id="ProjectSection_form" className={`ProjectSection_form needs-validation ${props.validation === "start" ? "" : "was-validated"}`} noValidate> {/** was-validated */}

                <div className="row">
                    {
                        mainArray?.map((item) => {

                            let formFieldDetails = item.FormFieldDetails && isJsonString(item.FormFieldDetails) ? JSON.parse(item.FormFieldDetails) : false
                            if(formFieldDetails){
                                let keyName = extractKeyName(formFieldDetails.object_path)

                                // Special handling for Project Type field (FormFieldID 7) - render as select using extraData
                                if(item.FormFieldID === 7){
                                    return  <label key={item.FormFieldID} htmlFor={keyName} className="form-label mb-2">
                                                <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                <div className="input-group input-group-sm mb-3">
                                                    <select
                                                        className={`form-select ${formErrors[keyName] ? "is-invalid" : ""}`}
                                                        value={props.formValsLocal?.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""}
                                                        onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)}
                                                        id={keyName}
                                                        required={item.IsRequired}
                                                        aria-label="select example">
                                                        <option value="">בחרו מהרשימה</option>
                                                        {
                                                            projectTypeOptions.map((option) => {
                                                                return <option key={option.key} value={option.key}>{option.title}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>
                                            </label>
                                }
                                // Special handling for Activity Field (FormFieldID 10) - render as select using extraData
                                else if(item.FormFieldID === 10){
                                    return  <label key={item.FormFieldID} htmlFor={keyName} className="form-label mb-2">
                                                <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                <div className="input-group input-group-sm mb-3">
                                                    <select
                                                        className={`form-select ${formErrors[keyName] ? "is-invalid" : ""}`}
                                                        value={props.formValsLocal?.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""}
                                                        onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)}
                                                        id={keyName}
                                                        required={item.IsRequired}
                                                        aria-label="select example">
                                                        <option value="">בחרו מהרשימה</option>
                                                        {
                                                            activityFieldOptions.map((option) => {
                                                                return <option key={option.key} value={option.key}>{option.title}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>
                                            </label>
                                }
                                // Special handling for Population field (FormFieldID 13) - render as select
                                else if(item.FormFieldID === 13){
                                    return  <label key={item.FormFieldID} htmlFor={keyName} className="form-label mb-2">
                                                <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                <div className="input-group input-group-sm mb-3">
                                                    <select
                                                        className={`form-select ${formErrors[keyName] ? "is-invalid" : ""}`}
                                                        value={props.formValsLocal?.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""}
                                                        onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)}
                                                        id={keyName}
                                                        required={item.IsRequired}
                                                        aria-label="select example">
                                                        <option value="">בחרו מהרשימה</option>
                                                        {
                                                            populationOptions.map((option) => {
                                                                return <option key={option.key} value={option.key}>{option.title}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>
                                            </label>
                                }
                                else if(fieldTypeDic[item.FormFieldType] === 'checkbox' || keyName === "IsOrganization" || keyName === "OrganizationName"){ 
                                    return  <div key={item.FormFieldID}>
                                                <div className={`form-group d-flex justify-content-between align-items-center ${item.FormFieldID !== 8 ? 'mb-3' : ''}`}>
                                                    <label htmlFor={keyName}>
                                                        <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                    </label>
                                                    {keyName !== "OrganizationName" &&
                                                        <CustomSwitchBox 
                                                            id={keyName} 
                                                            onChange={(e) => updateProjectDetailsObj(e.target.checked, keyName)}  
                                                            checked={props.formValsLocal?.ProjectDetails ? props.formValsLocal.ProjectDetails[keyName] : false}  />}                        
                                                </div>
                                                {keyName === "OrganizationName" &&
                                                <div className="input-group input-group-sm mb-3"> 
                                                    <input type="text" value={props.formValsLocal?.ProjectDetails[keyName] || ""} name={keyName} className={`form-control ${formErrors[keyName] ? "is-invalid" : ""}`} onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)} id={keyName} required={item.IsRequired} disabled={props.formValsLocal?.ProjectDetails ? !props.formValsLocal?.ProjectDetails["IsOrganization"] : false}/>                          
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>}
                                            </div>
                                }else if(fieldTypeDic[item.FormFieldType] === 'text' ||
                                        fieldTypeDic[item.FormFieldType] === 'tel' ||
                                        fieldTypeDic[item.FormFieldType] === 'email' ||
                                        fieldTypeDic[item.FormFieldType] === 'number'){
                                    return  <div key={item.FormFieldID} className={item.FormFieldID === 18 ? "w-100" : ""}>
                                                <label htmlFor={keyName} className="form-label mb-2 w-100">
                                                    <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                    <div className="input-group input-group-sm mb-3">
                                                        <input
                                                            type={fieldTypeDic[item.FormFieldType]}
                                                            value={props.formValsLocal.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""}
                                                            onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)}
                                                            className={`form-control ${formErrors[keyName] ? "is-invalid" : ""}`}
                                                            id={keyName} required={item.IsRequired}
                                                            onWheel={(e) => e.target.blur()}
                                                        />
                                                        <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                    </div>
                                                </label>
                                                {item.FormFieldID === 18 &&
                                                    <label className="form-label mb-2 w-100">
                                                        <span>*עיר</span>
                                                        <div className="input-group input-group-sm mb-3 position-relative">
                                                            {/* Hidden input for HTML5 validation */}
                                                            <input
                                                                type="text"
                                                                value={selectedCity?._id || ""}
                                                                onChange={() => {}} // Dummy onChange to suppress warning
                                                                required
                                                                style={{position: 'absolute', opacity: 0, pointerEvents: 'none', height: 0, width: 0}}
                                                                tabIndex={-1}
                                                            />
                                                            <Autocomplete
                                                                options={citiesList}
                                                                getOptionLabel={(option) => option.name || ""}
                                                                value={selectedCity}
                                                                onChange={handleCityChange}
                                                                filterOptions={(options, state) => {
                                                                    // Only show options if user has typed at least 2 characters
                                                                    if (!state.inputValue || state.inputValue.length < 2) {
                                                                        return [];
                                                                    }
                                                                    // Filter cities by name
                                                                    return options.filter(option =>
                                                                        option.name.includes(state.inputValue)
                                                                    );
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        size="small"
                                                                        placeholder="הקלד לפחות 2 תווים לחיפוש עיר"
                                                                        InputProps={{
                                                                            ...params.InputProps,
                                                                            className: `form-control ${props.validation !== "start" ? (formErrors["CityId"] || !selectedCity ? "is-invalid" : "is-valid") : ""}`
                                                                        }}
                                                                    />
                                                                )}
                                                                noOptionsText="הקלד לפחות 2 תווים לחיפוש"
                                                                fullWidth
                                                                componentsProps={{
                                                                    paper: {
                                                                        sx: {
                                                                            borderRadius: '0 !important',
                                                                            fontFamily: 'almoni-neue-regular !important'
                                                                        }
                                                                    }
                                                                }}
                                                                sx={{
                                                                    '& .MuiTextField-root': {
                                                                        width: '100%'
                                                                    },
                                                                    '& .MuiOutlinedInput-root': {
                                                                        padding: '0',
                                                                        paddingRight: '4rem !important',
                                                                        border: 'none !important',
                                                                        borderRadius: '0 !important',
                                                                        minHeight: 'calc(1.5em + 0.5rem + 2px)',
                                                                        height: 'calc(1.5em + 0.5rem + 2px)',
                                                                        backgroundImage: props.validation !== "start"
                                                                            ? (formErrors["CityId"] || !selectedCity
                                                                                ? 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 12 12\' width=\'12\' height=\'12\' fill=\'none\' stroke=\'%23dc3545\'%3e%3ccircle cx=\'6\' cy=\'6\' r=\'4.5\'/%3e%3cpath stroke-linejoin=\'round\' d=\'M5.8 3.6h.4L6 6.5z\'/%3e%3ccircle cx=\'6\' cy=\'8.2\' r=\'.6\' fill=\'%23dc3545\' stroke=\'none\'/%3e%3c/svg%3e") !important'
                                                                                : 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 8 8\'%3e%3cpath fill=\'%2328a745\' d=\'M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z\'/%3e%3c/svg%3e") !important')
                                                                            : 'none !important',
                                                                        backgroundRepeat: 'no-repeat !important',
                                                                        backgroundPosition: 'left calc(0.375em + 0.1875rem) center !important',
                                                                        backgroundSize: 'calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important',
                                                                        '& fieldset': {
                                                                            border: 'none !important'
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            border: 'none !important'
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            border: 'none !important'
                                                                        }
                                                                    },
                                                                    '& .MuiAutocomplete-inputRoot': {
                                                                        padding: '0 !important',
                                                                        minHeight: 'calc(1.5em + 0.5rem + 2px) !important',
                                                                        height: 'calc(1.5em + 0.5rem + 2px) !important'
                                                                    },
                                                                    '& .MuiInputBase-input': {
                                                                        padding: '0.25rem 0.5rem !important',
                                                                        paddingLeft: 'calc(0.75em + 0.375rem + 1.25rem) !important',
                                                                        height: 'auto !important',
                                                                        minHeight: 'unset !important',
                                                                        fontFamily: 'almoni-neue-regular !important'
                                                                    },
                                                                    '& .MuiAutocomplete-endAdornment': {
                                                                        right: '0.5rem !important',
                                                                        top: 'calc(50% - 12px + 10px) !important',
                                                                        '& .MuiAutocomplete-clearIndicator': {
                                                                            padding: '2px !important',
                                                                            marginLeft: '2px !important'
                                                                        },
                                                                        '& .MuiAutocomplete-popupIndicator': {
                                                                            padding: '2px !important',
                                                                            marginRight: '2px !important'
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                            <div className="invalid-feedback">{props.errorsObjReady["CityId"] || "יש לבחור עיר"}</div>
                                                        </div>
                                                    </label>
                                                }
                                            </div>
                                }else if(fieldTypeDic[item.FormFieldType] === 'textarea'){
                                    return  <label key={item.FormFieldID} htmlFor={keyName} className="form-label mb-2">
                                                <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                <div className="input-group input-group-sm mb-3"> 
                                                    <textarea
                                                    rows={6}
                                                    onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)} 
                                                    value={props.formValsLocal.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""}
                                                    className={`form-control ${formErrors[keyName] ? "is-invalid" : ""}`} id={keyName} required={item.IsRequired}></textarea>                             
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>
                                            </label>
                                }else if(fieldTypeDic[item.FormFieldType] === 'SelectSingle'){
                                    return  <label key={item.FormFieldID} htmlFor={keyName} className="form-label mb-2">
                                                <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                <div className="input-group input-group-sm mb-3"> 
                                                    <select className={`form-select ${formErrors[keyName] ? "is-invalid" : ""}`} value={props.formValsLocal?.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""} onChange={(e) => updateProjectDetailsObj(Number(e.target.value), keyName)} id={keyName} required={item.IsRequired} aria-label="select example">
                                                        <option value="">בחרו מהרשימה</option>
                                                        {
                                                        formFieldDetails.select_values ? formFieldDetails.select_values.map((subItem) => {
                                                                return <option key={subItem.id} value={subItem.id}>{subItem.title}</option>
                                                            }) : null
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                </div>
                                            </label>
                                }else if(fieldTypeDic[item.FormFieldType] === 'Time'){
                                    return  <div key={item.FormFieldID} className="col-6">
                                                <label htmlFor={keyName} className="form-label mb-2 w-100">
                                                    <span>{item.IsRequired ? "*" : ""}{item.Title}</span>
                                                    <div className="input-group input-group-sm mb-3"> 
                                                        <select className={`form-select ${formErrors[keyName] ? "is-invalid" : ""}`} value={props.formValsLocal.ProjectDetails ? props.formValsLocal?.ProjectDetails[keyName] : ""} onChange={(e) => updateProjectDetailsObj(e.target.value, keyName)} id={keyName} required={item.IsRequired} aria-label="select example">
                                                            <option value="">בחרו מהרשימה</option>
                                                            {
                                                                hoursArray?.map((subItem, index) => {
                                                                    return <option key={'hours_' + index} value={subItem.hourValue}>{subItem.hour}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback">{props.errorsObjReady[keyName] || `יש למלא ${item.Title}`}</div>
                                                    </div>
                                                </label>
                                            </div>
                                }
                            }

                        })
                    }
                </div>

            </form></>
}